export default "__VITE_ASSET__CkjrCByC__"